import React from "react";
import WalletsLine from "./WalletsLine";
import { List, ListSubheader } from "@mui/material";
import { groupWalletsByCategory } from "../../../../components/common/groupWalletsByCategory";
import { useTranslation } from "react-i18next";
import { returnCategoryTranslation } from "./Functions/returnCategoryTranslation";

export default function WalletsList({ type, wallets }) {
	const { t } = useTranslation();
	if (type === "cash") {
		return (
			<List sx={{ pt: 0, pb: 0, pl: 1 }}>
				{wallets.map((wallet) => (
					<WalletsLine wallet={wallet} type={type} key={wallet._id} />
				))}
			</List>
		);
	}

	const groupedWallets = groupWalletsByCategory(wallets);

	return (
		<List sx={{ pt: 0, pb: 0, pl: 1 }}>
			{Object.entries(groupedWallets).map(([category, items]) => (
				<React.Fragment key={category}>
					<ListSubheader
						sx={{ lineHeight: "1.5", fontWeight: "bold" }}
					>
						{returnCategoryTranslation(t, category)}
					</ListSubheader>
					{items.map((wallet) => (
						<WalletsLine
							wallet={wallet}
							type={type}
							key={wallet._id}
						/>
					))}
				</React.Fragment>
			))}
		</List>
	);
}
